import React from 'react'
import { ProjectCardProps } from 'types';
import { ListTodo, MessageCircleMore } from 'lucide-react'
import { useNavigate } from 'react-router-dom';
import { projectLabels, projectStatusVal, repareURL, ROUTES } from 'utils';
import AvatarCharecter from './AvatarCharecter';
import { AvatarImage } from 'components';

export const ProjectCard: React.FC<ProjectCardProps> = ({
    code,
    name,
    description,
    total_task,
    total_cmd,
    members,
    percent,
    status,
    avatar,
}) => {
    const router = useNavigate()
    return (
        <div className="bg-white relative rounded-xl shadow w-full max-w-[500px] cursor-pointer" onClick={() => router(`${ROUTES.PRIVATE_ROOT.PROJECTS_DETAIL}/${code}`)}>
            {status && (
                <span
                    className={`absolute top-2 right-2 inline-block text-xs px-2 py-1 rounded-md font-semibold mb-2 ${projectLabels[status]}`}
                >
                    {projectStatusVal[status]}
                </span>
            )}

            {avatar && <div className="mb-4"><img src={repareURL(avatar)} alt="Avatar" className="w-full rounded-t-lg" /></div>}

            <div className="p-5">
                <h3 className="font-semibold text-gray-800">{name}</h3>
                <p className="text-sm text-gray-500 line-clamp-2 mb-3">{description}</p>

                <div className="flex items-center text-sm text-gray-500 gap-4 mb-3">
                    <span className="flex row items-center"><ListTodo width={16} className='mr-2' /> {total_task} nhiệm vụ</span>
                    <span className="flex row items-center"><MessageCircleMore width={16} className='mr-2' /> {total_cmd} bình luận</span>
                </div>

                {!!members?.length && <div className="flex -space-x-2 mb-3">
                    {[...Array(Math.min(members?.length, 3))].map((_, i) => {

                        return members[i]?.avatar ? (
                            <AvatarImage
                                key={`im-${i}`}
                                src={repareURL(members[i]?.avatar)}
                                className="w-8 h-8 rounded-full border-2 border-white"
                                alt={members[i]?.name}
                            />
                        ) : <AvatarCharecter name={members[i]?.name} key={i} className="w-8 h-8" />
                    })}
                    {members?.length > 3 && (
                        <span className="text-xs bg-gray-100 text-gray-700 rounded-full px-2 py-1">
                            +{members?.length - 3} thêm
                        </span>
                    )}
                </div>}
                <div>
                    <div className="flex justify-between text-sm mb-1">
                        <span>Tiến độ</span>
                        <span className="font-semibold">{percent}%</span>
                    </div>
                    <div className="h-2 w-full bg-gray-200 rounded-full">
                        <div className={`h-2 bg-blue-500 rounded-full`}
                            style={{ width: `${percent}%` }} />
                    </div>
                </div>
            </div>
        </div>
    )
}

